import { render, staticRenderFns } from "./SendMessageTemplateList.vue?vue&type=template&id=2ef94efe&scoped=true&lang=pug"
import script from "./SendMessageTemplateList.vue?vue&type=script&lang=ts"
export * from "./SendMessageTemplateList.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTemplateList.vue?vue&type=style&index=0&id=2ef94efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef94efe",
  null
  
)

export default component.exports